// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/map-projections.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/map-projections/map-projections.js';

mount([g0]);
